import React from "react";
import { connect } from "react-redux";

import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";
import { loadTabs } from "../../../Header/actions";

import PreNominasGrafico from "./prenominas";
import NominasGrafico from "./nominas";
import ConsultasGrafico from "./consultas";
import DiasReposoGrafico from "./diasReposo";
import DatosEmpresaGrafico from "./datosEmpresa";


class PanelCovid19 extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== "Panel COVID - 19") {
      this.loadTabs();
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) tabs.push({ text: "Pre - nóminas Empresa", contentId: 0 });
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) tabs.push({ text: "Nóminas Minsal", contentId: 1 });
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) tabs.push({ text: "Presentaciones", contentId: 2 });
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) tabs.push({ text: "Días de reposo", contentId: 3 });
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) tabs.push({ text: "Datos Empresa", contentId: 4 });

    this.props.dispatch(loadTabs(
      "Panel COVID - 19",
      "Información relacionada a trabajadores que están considerados en una Pre-nómina, Nómina Minsal o que han consultado en algún centro ACHS por cualquier motivo asociado a COVID-19",
      tabs,
      tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {

      case 0: {
        return (<PreNominasGrafico />);
      }

      case 1: {
        return (<NominasGrafico />);
      }

      case 2: {
        return (<ConsultasGrafico />);
      }

      case 3: {
        return (<DiasReposoGrafico />);
      }

      case 4: {
        return (<DatosEmpresaGrafico />);
      }

      default:
        return <div />;
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderBody()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelCovid19);
